<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-5">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{
        'shipment.dialog.shipmentDetails.title'
          | translate: { fileId: $safeNavigationMigration(data?.shipmentFileId) }
      }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>
  @if (isLoadingShipmentDetails) {
    <div>
      <div class="flex flex-col gap-5">
        <div class="bg-surface rounded-xl xl:px-24 px-3 py-2 flex justify-between">
          <div>
            <div class="text-body-md font-semibold text-center">
              {{ 'settings.first.content.detail.devices' | translate }}
            </div>
            <div class="text-2xl font-medium text-crimson text-center">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
        </div>
        <!-- <div>
        <div class="text-xl font-semibold mb-2">
          {{ 'locations.detailTabs.company.label' | translate }}
        </div>
        <div class="flex flex-col gap-2">
          @for (item of data.company; track $index) {
            <div
              class="border border-border-card rounded-lg py-2 px-3 flex justify-between items-center gap-3">
              <div class="flex items-center gap-3 min-w-60">
                <div class="h-8 w-8 rounded-full">
                  <xemex-skeleton-block
                    [width]="'100%'"
                  [height]="'100%'"></xemex-skeleton-block>
                </div>
                <div>
                  <div class="text-body">
                    <xemex-skeleton-block></xemex-skeleton-block>
                  </div>
                </div>
              </div>
              <div class="text-body whitespace-nowrap">
                <xemex-skeleton-block></xemex-skeleton-block>
              </div>
              <div class="text-body whitespace-nowrap">
                <xemex-skeleton-block></xemex-skeleton-block>
              </div>
              <div class="text-body whitespace-nowrap min-w-60">
                <xemex-skeleton-block></xemex-skeleton-block>
              </div>
            </div>
          }
        </div>
      </div> -->
        <div>
          <div class="text-xl font-semibold">
            {{ 'settings.first.content.detail.devices' | translate }}
          </div>
          <div class="bg-tertiary overflow-hidden w-full h-full z-10 justify-center items-center">
            <xemex-skeleton-table
              [columns]="columnsConfig"
              [totalNumberOfRows]="5"
            ></xemex-skeleton-table>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="flex flex-col gap-5 h-full overflow-auto">
      <div class="bg-surface rounded-xl xl:px-24 px-3 py-2 flex justify-between">
        <div>
          <div class="text-body-md font-semibold text-center">
            {{ 'settings.first.content.detail.devices' | translate }}
          </div>
          <div class="text-2xl font-medium text-neutral text-center">
            {{ shipmentDetails?.numberOfDevices }}
          </div>
        </div>
      </div>
      <!-- <div>
    <div class="text-xl font-semibold mb-2">
      {{ 'locations.detailTabs.company.label' | translate }}
    </div>
    <div class="flex flex-col gap-2">
      @for (item of data.company; track $index) {
        <div
          class="border border-border-card rounded-lg py-2 px-3 flex justify-between items-center gap-3">
          <div class="flex items-center gap-3 min-w-60">
            <img
                [src]="
                  item.avatar
                    ? item.avatar
                    : '/assets/images/illustration/dummy-avatar.jpg'
                "
              class="h-8 w-8 rounded-full" />
            <div>
              <div class="text-body">{{ item.name }}</div>
            </div>
          </div>
          <div class="text-body whitespace-nowrap"><{{ item.number }}></div>
          <div class="text-body whitespace-nowrap">{{ item.user }}</div>
          <div class="text-body whitespace-nowrap min-w-60">
            {{ item.address }}
          </div>
        </div>
      }
    </div>
  </div> -->
      <div>
        <div class="text-xl font-semibold">
          {{ 'settings.first.content.detail.devices' | translate }}
        </div>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="deviceLDN">
            <th mat-header-cell *matHeaderCellDef>
              <div class="flex items-center">
                <span>{{ 'devices.table.deviceLDN' | translate }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center">
                <div class="flex items-center gap-2 flex-nowrap">
                  <div>
                    <div class="h-10 w-10 rounded-md bg-gray-500"></div>
                  </div>
                  <span class="text-body">{{ element.deviceLDN }}</span>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="simStatus">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'devices.table.simStatus' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <xemex-status-chip status="success" [label]="element.simStatus" />
            </td>
          </ng-container>
          <ng-container matColumnDef="installationStatus">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'devices.table.installationStatus' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.installationStatus }}
            </td>
          </ng-container>
          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'devices.table.customerName' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.customerName }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="cursor-pointer hover:!bg-primary-hover"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">
              <div class="text-gray-300 text-xl text-center mt-9">
                {{ 'general.noData' | translate }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  }

  <div>
    <xemex-outlined-button (click)="onDownload()" [disabled]="isLoadingShipmentContent">
      @if (isLoadingShipmentContent) {
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDownload' | translate }}</span>
          <xemex-spinner size="sm"></xemex-spinner>
        </div>
      } @else {
        {{ 'general.btnDownload' | translate }}
      }
    </xemex-outlined-button>
    <xemex-filled-button class="float-right" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</div>
